<template>
  <path
    d="M14.7801 23.3533C15.4533 24.0265 15.4517 25.1185 14.7766 25.7897C14.104 26.4586 13.0169 26.4568 12.3465 25.7857L2.37323e-06 13.4267L12.3599 1.06684C13.03 0.396714 14.1165 0.396714 14.7866 1.06684C15.4568 1.73696 15.4568 2.82345 14.7866 3.49357L4.85347 13.4267L14.7801 23.3533Z"
  />
</template>
